export const NON_STATIC_ITEMS = [
  {
    label: "24h sum",
    value: "24h_sum",
  },
  {
    label: "24h trend",
    value: "24h_trend",
  },
  {
    label: "7d avg",
    value: "7d_avg",
  },
  {
    label: "7d sum",
    value: "7d_sum",
  },
  {
    label: "7d trend",
    value: "7d_trend",
  },
  {
    label: "30d avg",
    value: "30d_avg",
  },
  {
    label: "30d sum",
    value: "30d_sum",
  },
  {
    label: "30d trend",
    value: "30d_trend",
  },
  {
    label: "90d avg",
    value: "90d_avg",
  },
  {
    label: "90d sum",
    value: "90d_sum",
  },
  {
    label: "90d trend",
    value: "90d_trend",
  },
  {
    label: "180d avg",
    value: "180d_avg",
  },
  {
    label: "180d sum",
    value: "180d_sum",
  },
  {
    label: "180d trend",
    value: "180d_trend",
  },
  {
    label: "365d avg",
    value: "365d_avg",
  },
  {
    label: "365d sum",
    value: "365d_sum",
  },
  {
    label: "365d trend",
    value: "365d_trend",
  },
  {
    label: "ATH",
    value: "max_ath",
  },
  {
    label: "ATL",
    value: "max_atl",
  },
]

export const STATIC_ITEMS = [
  {
    label: "Latest",
    value: "max_latest",
  },
  {
    label: "24h avg",
    value: "24h_avg",
  },
  {
    label: "24h sum",
    value: "24h_sum",
  },
  {
    label: "24h change",
    value: "24h_change",
  },
  {
    label: "7d avg",
    value: "7d_avg",
  },
  {
    label: "7d sum",
    value: "7d_sum",
  },
  {
    label: "7d change",
    value: "7d_change",
  },
  {
    label: "30d avg",
    value: "30d_avg",
  },
  {
    label: "30d sum",
    value: "30d_sum",
  },
  {
    label: "30d change",
    value: "30d_change",
  },
  {
    label: "90d avg",
    value: "90d_avg",
  },
  {
    label: "90d sum",
    value: "90d_sum",
  },
  {
    label: "90d change",
    value: "90d_change",
  },
  {
    label: "180d avg",
    value: "180d_avg",
  },
  {
    label: "180d sum",
    value: "180d_sum",
  },
  {
    label: "180d change",
    value: "180d_change",
  },
  {
    label: "365d avg",
    value: "365d_avg",
  },
  {
    label: "365d sum",
    value: "365d_sum",
  },
  {
    label: "365d change",
    value: "365d_change",
  },
  {
    label: "ATH",
    value: "max_ath",
  },
  {
    label: "ATL",
    value: "max_atl",
  },
]
